import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';

@doc.path('/plan_analyses/{id}/mapping')
export default class PlanAnalysisMappingModel extends MapServiceModel {
}
